module.exports = __webpack_public_path__ + "img/17.a55abd95.jpg";